export const slickAtts = {
  slidesToShow: 3,
  slidesToScroll: 2,
  centerMode: false,
  dots: false,
  infinite: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 980, // tablet breakpoint
      settings: {
        slidesToShow: 3,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 768, // mobile breakpoint
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 576, // mobile breakpoint
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./scripts/functions/slider.js